const PagesTitleCtrl = (data: IPageInfo) => {

    const validate = (txt: string | undefined): boolean => (txt !== '' && txt !== undefined);
    return (
        <>
            {validate(data.title1) &&
                <div className="lbl-paso-t1 mt-10">
                    <span className="">{data.title1}</span>
                </div>
            }
            {validate(data.title2) &&
                <div className="mt-10">
                    <span className="lbl-paso-t2">(<span style={{color: '#FF5F49'}}>*</span>) {data.title2}</span>
                </div>
            }
            {validate(data.title3) &&
                <div className="mt-5 mb-30">
                    <span className="lbl-paso-t3">{data.title3} </span>
                </div>
            }
        </>
    );
}

export { PagesTitleCtrl }